export const FilterData = {
  Published: [
    {
      title: 'Newest - Oldest',
      value: 'newest',
    },
    {
      title: 'Oldest - Newest',
      value: 'oldest',
    },
  ],
};

export const productDetailsData = {
  size: [
    {
      title: 'XL',
      value: 'X-Large',
    },
    {
      title: 'L',
      value: 'Large',
    },
    {
      title: 'M',
      value: 'Medium',
    },
    {
      title: 'S',
      value: 'Small',
    },
    {
      title: 'XS',
      value: 'X-Small',
    },
  ],
  colors: [
    {
      title: 'White',
      color: '#FFFFFF',
    },
    {
      title: 'Black',
      color: '#000000',
    },
    {
      title: 'Maroon',
      color: '#800000',
    },

    {
      title: 'Olive',
      color: '#808000',
    },
    {
      title: 'Teal',
      color: '#008080',
    },

    {
      title: 'Brown',
      color: '#A0522D',
    },
  ],
};
